import { Listing } from "./Models/Listing"
import { ListingAfterHoursMessageType } from "./main";

const TOWING = 'TOW';
const MOBILE = ['MRS', 'MTIRE'];

export default {
    getAfterHoursStatusType: function (listing: Listing) {
        if (listing.services.some(s => MOBILE.some(m => s.code == m))) {
            return ListingAfterHoursMessageType.Road;
        }

        if (listing.services.some(s => s.code == TOWING)) {

            return ListingAfterHoursMessageType.Towing;
        }

        return ListingAfterHoursMessageType.Emergency;
    },

    getAfterHoursListingStatus: function (type: ListingAfterHoursMessageType) {
        switch (type) {
            case ListingAfterHoursMessageType.Towing:
                return 'Towing Service Only';
            case ListingAfterHoursMessageType.Road:
                return 'Road Service Only';
            case ListingAfterHoursMessageType.Emergency:
                return 'Emergency Service Only';
            default:
                return '';
        }
    },

    getAfterHoursListingHoursEntrySuffix: function (type: ListingAfterHoursMessageType) {
        switch (type) {
            case ListingAfterHoursMessageType.Towing:
                return ' (towing service)';
            case ListingAfterHoursMessageType.Road:
                return ' (road service)';
            case ListingAfterHoursMessageType.Emergency:
                return ' (emergency service)';
            default:
                return '';
        }
    },

    getAfterHoursListing24HourEntryMessage: function (type: ListingAfterHoursMessageType) {
        switch (type) {
            case ListingAfterHoursMessageType.Towing:
                return '24 hour towing service';
            case ListingAfterHoursMessageType.Road:
                return '24 hour road service';
            case ListingAfterHoursMessageType.Emergency:
                return '24 hour emergency service';
            default:
                return '';
        }
    }
};